module.exports = __webpack_public_path__ + "img/tools-dao.0eb0f18e.png";